/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SelectionState,
  IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  VirtualTable,
  TableColumnVisibility,
  TableSelection,
} from '@devexpress/dx-react-grid-material-ui';

import { useLazyQuery, useMutation } from '@apollo/client';
import {
  createdAtFormatter,
  currencyFormatterEmpty,
  dueAmountFormatter,
  incomeAmountFormatter,
  invoiceReceiptFormatter,
  nameLinkFormat,
  progressFormatter,
  taskNameFormatter,
} from './colorFormat';
import { getColumns } from '../common/columns';
import getTasks from '../graphql/query/getTasks';

import { TableComponent } from './TableComponent';

import { Box, Button, Typography } from '@material-ui/core';
import RefetchBox from './RefetchBox';
import useEmployees from '../hooks/useEmployees';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import updateTasksEmployee from '../graphql/mutation/updateTasksEmployee';

export const getRowId = (row: { _id: any }) => row._id;

export default function TasksCustomer({
  isRTL,
  words,
  theme,
  name,
  id,
  width,
  height,
  start,
  end,
}) {
  const col = getColumns({ isRTL, words });
  const [columns] = useState([
    col.title,
    // col.docNo,
    col.start,
    col.end,
    col.customer,
    col.department,
    col.employee,
    col.evQty,
    col.progress,
    { name: 'amount', title: isRTL ? 'الاجمالي' : 'Total' },
    col.totalinvoiced,
    col.totalpaid,
    {
      id: 40,
      ref: 'due',
      name: 'due',
      title: isRTL ? 'المتبقي' : 'Due Payment',
    },
    col.toatlExpenses,
    {
      id: 38,
      ref: 'income',
      name: 'income',
      title: isRTL ? 'صافي الايراد' : 'Total Income',
    },
  ]);

  const [rows, setRows] = useState([]);

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  // Selection and employee change states
  const [selection, setSelection] = useState<any>([]);
  const [newEmplvalue, setNewEmplvalue] = useState<any>(null);
  const [updating, setUpdating] = useState(false);

  const { employeesfull: employees } = useEmployees();

  const [loadTasks, tasksData]: any = useLazyQuery(getTasks, {
    fetchPolicy: 'cache-and-network',
  });

  const [updateEmployeeMutation] = useMutation(updateTasksEmployee, {
    refetchQueries: [
      {
        query: getTasks,
        variables: {
          [name]: id,
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      },
    ],
  });

  useEffect(() => {
    if (openItem) {
      const tsks = tasksData?.data?.['getTasks']?.data || [];
      if (tsks && tsks.length > 0) {
        const opened = tsks.filter((ts: any) => ts._id === item._id)?.[0];
        setItem(opened);
      }
    }
  }, [tasksData]);

  useEffect(() => {
    const variables = {
      [name]: id,
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
    };
    loadTasks({
      variables,
    });
  }, [id, start, end]);

  const [tableColumnVisibilityColumnExtensions] = useState([
    { columnName: col.title.name, togglingEnabled: false },
  ]);

  useEffect(() => {
    if (tasksData?.data?.getTasks?.data) {
      const { data } = tasksData.data.getTasks;
      setRows(data);
    }
  }, [tasksData]);

  const handleUpdateEmployee = async () => {
    if (!newEmplvalue || selection.length === 0) return;
    setUpdating(true);
    try {
      const employee = {
        employeeId: newEmplvalue._id,
        employeeName: newEmplvalue.name,
        employeeNameAr: newEmplvalue.nameAr,
        employeeColor: newEmplvalue.color,
        employeePhone: newEmplvalue.phone,
      };
      await updateEmployeeMutation({
        variables: {
          ids: selection,
          employee,
        },
      });
      setSelection([]);
      setNewEmplvalue(null);
    } catch (error) {
      console.log('error', error);
    }
    setUpdating(false);
  };

  const refresh = () => tasksData?.refetch();
  const loading = tasksData.loading;
  return (
    <Box
      style={{
        height: height - 250,
        width: width - 300,
        margin: 10,
      }}
    >
      <Box
        style={{
          position: 'absolute',
          width: 50,
          height: 50,
          left: isRTL ? 220 : undefined,
          right: isRTL ? undefined : 220,
          zIndex: 111,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: 55,
        }}
      >
        <RefetchBox
          isRTL={isRTL}
          theme={theme}
          refresh={refresh}
          loading={loading}
        ></RefetchBox>
      </Box>
      <Paper
        style={{
          height: height - 260,
          width: width - 320,
        }}
      >
        {name === 'employeeId' && (
          <Box
            style={{
              display: 'flex',
              margin: 5,
              padding: 5,
              marginBottom: -5,
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Box style={{ width: 250, marginRight: 10, marginLeft: 10 }}>
              <AutoFieldLocal
                name="newEmployee"
                title={isRTL ? 'موظف جديد' : 'New Employee'}
                words={words}
                options={
                  employees?.filter(
                    (emp: any) => !emp.disabled && emp._id !== id,
                  ) || []
                }
                value={newEmplvalue}
                setSelectValue={setNewEmplvalue}
                isRTL={isRTL}
                fullWidth
              ></AutoFieldLocal>
            </Box>
            <Button
              color="primary"
              variant="contained"
              disabled={selection?.length === 0 || !newEmplvalue || updating}
              onClick={handleUpdateEmployee}
              style={{ marginLeft: 10, marginRight: 10, height: 40 }}
            >
              <Typography style={{ fontSize: 12 }}>
                {updating
                  ? isRTL
                    ? 'جاري التحديث...'
                    : 'Updating...'
                  : isRTL
                    ? 'تغيير الموظف'
                    : 'Change Employee'}
              </Typography>
            </Button>
            {selection?.length > 0 && (
              <Typography style={{ marginLeft: 10, marginRight: 10 }}>
                {isRTL
                  ? `${selection.length} محدد`
                  : `${selection.length} selected`}
              </Typography>
            )}
          </Box>
        )}
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <SortingState />
          <IntegratedSorting />
          {name === 'employeeId' && (
            <SelectionState
              selection={selection}
              onSelectionChange={setSelection}
            />
          )}
          {name === 'employeeId' && <IntegratedSelection />}
          <VirtualTable
            height={680}
            messages={{
              noData: isRTL ? 'لا يوجد بيانات' : 'no data',
            }}
            estimatedRowHeight={40}
            tableComponent={TableComponent}
          />
          <TableHeaderRow
            showSortingControls
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <TableColumnVisibility
            columnExtensions={tableColumnVisibilityColumnExtensions}
            defaultHiddenColumnNames={[
              col.department.name,
              col.evQty.name,
              col.toatlExpenses.name,
              col.start.name,
              col.end.name,
            ]}
          />
          <DataTypeProvider
            for={['title']}
            formatterComponent={(props: any) =>
              nameLinkFormat({ ...props, setItem, setOpenItem })
            }
          ></DataTypeProvider>
          <DataTypeProvider
            for={['start', 'end']}
            formatterComponent={createdAtFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['due']}
            formatterComponent={dueAmountFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['amount', 'toatlExpenses', 'totalpaid']}
            formatterComponent={currencyFormatterEmpty}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['totalinvoiced']}
            formatterComponent={invoiceReceiptFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['income']}
            formatterComponent={incomeAmountFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['tasktype']}
            formatterComponent={taskNameFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['progress']}
            formatterComponent={progressFormatter}
          ></DataTypeProvider>
          {name === 'employeeId' && <TableSelection showSelectAll />}
        </Grid>
      </Paper>
    </Box>
  );
}
